import { MbscDatepickerOptions } from "@mobiscroll/angular";

export const datePickerOptions: MbscDatepickerOptions = {
    display: "inline",
    firstSelectDay: 1,
    showWeekNumbers: true
};

